// removed by extract-text-webpack-plugin
module.exports = {"header":"src-layouts-components----Header-module---header---GlKCZ","titleNavWrapper":"src-layouts-components----Header-module---titleNavWrapper---3znzs","nameContainer":"src-layouts-components----Header-module---nameContainer---164F6","siteTitle":"src-layouts-components----Header-module---siteTitle---1WyeS","desktopNav":"src-layouts-components----Header-module---desktopNav---3c2Zu","mainNav":"src-layouts-components----Header-module---mainNav---x2Rph"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/Header.module.css
// module id = 310
// module chunks = 114276838955818